/* eslint-disable jsx-a11y/anchor-is-valid */
import React from "react";
import { Link, useLocation } from "react-router-dom";
import { hashSections, routesList } from "../Common";
import PDF from "../Documents/Supercreators_v2.pdf";
import { CommonLoader } from "../Loaders";

const Footer = () => {
  const history = useLocation();
  const appendActiveClass = (path) => {
    if (history && history.pathname === path) {
      return ` active`;
    }
    return ``;
  };
  return (
    <>
      <footer className="footer">
        {window.location.pathname === routesList.homePage && (
          <div className="white-paper">
            <div className="container">
              <div className="paer-text">
                <h2>Whitepaper</h2>
                <div className="subtitle">
                  Click below and view our whitepaper to get an in-depth
                  explanation of the Super Creators NFT Project
                </div>
                <a
                  className="btn"
                  href={PDF}
                  target={"_blank"}
                  rel="noreferrer"
                >
                  Download
                </a>
              </div>
              <hr />
            </div>
          </div>
        )}
        <div className="copyright">
          <div className="container">
            <div className="social-row">
              <ul>
                <li>
                  {" "}
                  <a
                    href={"https://twitter.com/SuperCreatorNFT"}
                    target={"_blank"}
                    rel="noreferrer"
                  >
                    <i className="bi bi-twitter"></i>
                  </a>{" "}
                </li>
                <li>
                  {" "}
                  <a
                    href={"https://discord.gg/2XGJMR7sfw"}
                    target={"_blank"}
                    rel="noreferrer"
                  >
                    <i className="bi bi-discord"></i>
                  </a>{" "}
                </li>
                <li>
                  {" "}
                  <a
                    href={"https://www.instagram.com/iamverseofficial/"}
                    target={"_blank"}
                    rel="noreferrer"
                  >
                    <i className="bi bi-instagram"></i>
                  </a>{" "}
                </li>
              </ul>
            </div>
            <div className="footer-links">
              <ul>
                <li>
                  <a
                    className={`nav-link closeSideBar${appendActiveClass(
                      routesList.homePage
                    )}`}
                    aria-current="page"
                    href={routesList.homePage}
                  >
                    Home
                  </a>
                </li>
                <li className="nav-item">
                  <a className="nav-link" href={hashSections.aboutUs}>
                    About us
                  </a>
                </li>
                <li className="nav-item">
                  <a className="nav-link" href={hashSections.roadmap}>
                    Roadmap
                  </a>
                </li>
                <li className="nav-item">
                  <a className="nav-link" href={hashSections.team}>
                    Team
                  </a>
                </li>
              </ul>
            </div>
            <div className="privacy">
              Copyright © 2021 Copyright I Am Creator. All rights reserved.{" "}
              <a
                href={"https://www.iamcreator.com/terms-and-conditions/"}
                target={"_blank"}
                rel="noreferrer"
              >
                Privacy Terms & Conditions
              </a>
            </div>
            <div className="mt-2 text-center powered-by">
              <a
                href="https://semidotinfotech.com"
                target={"_blank"}
                rel="noreferrer"
              >
                {" "}
                <img
                  src="assets/images/powered-by.png"
                  alt="powered by Semidot Infotech"
                />
              </a>
            </div>
          </div>
        </div>
      </footer>
      <div className="overlay hide"></div>
      <CommonLoader />
    </>
  );
};

export default Footer;
